import {ESBA_DATE_FORMAT} from "../../../common";
import DatePicker, {ReactDatePickerProps} from "react-datepicker";
import {memo} from "react";
import {Controller, useFormContext} from "react-hook-form";
import {parseISO} from "date-fns";
import {PractitionerCareTeamInput} from "../domain";
import {CustomDateInput} from "../../component/CustomDateInput";

type CareTeamEndDateInputProps = {
    sending: boolean;
} & Omit<ReactDatePickerProps, 'onChange'>;
export const PractitionerCareTeamEndDateInput = memo(({
                                              sending,
                                              ...datePickerProps
                                          }: CareTeamEndDateInputProps) => {
    const {
        control,
        getValues,
        formState: {
            errors
        },
    } = useFormContext<PractitionerCareTeamInput>();

    return (
        <li className="w-full flex text-base items-center pb-2">
            <div className="w-2/6 text-right">
                End Date
            </div>
            <Controller
                name='endDate'
                control={control}
                rules={{
                    validate: (value) => value === undefined || value === null || value >= getValues("startDate")
                }}
                render={({field: {onChange, onBlur, value: isoValueStr}}) => <DatePicker
                    wrapperClassName="w-3/6"
                    {...datePickerProps}
                    disabled={sending}
                    onChange={(newValue: Date | null) => onChange(newValue?.toISOString() || null)}
                    onBlur={onBlur}
                    selected={isoValueStr ? parseISO(isoValueStr) : undefined}
                    dateFormat={ESBA_DATE_FORMAT}
                    minDate={new Date()} // disable past date
                    customInput={
                        <CustomDateInput
                            fieldName="endDate"
                            value={new Date().toISOString()}
                            errorMsg={errors.endDate ? errors.endDate.type === "validate" ? '"End Date" must after "Start Date"' : "Required" : undefined}
                        />
                    }
                />}
            />
        </li>
    );
});
